
export function SpinnerInterceptorFunction(
    $q,
    $rootScope,
    $interval,
    $timeout
) {
    'ngInject';

    const STATUS_BAD_REQUEST = 400;
    const spinner = new Spinner($rootScope, $timeout);
    const progressBar = new ProgressBar($rootScope);

    return {
        request,
        response,
        responseError,
    };

    function request(config) {
        if (isSpinnerHasToBeShown({config})) {
            spinner.start(config);
        }

        if (isProgressBarHasToBeShown({config})) {
            progressBar.start(config);
        }
        return config;
    }

    function response(payload) {
        if (isSpinnerHasToBeShown(payload)) {
            spinner.stop(payload);
        }
        if (isProgressBarHasToBeShown(payload)) {
            progressBar.stop(payload);
        }

        return payload;
    }

    function responseError(payload) {
        if (!payload.config) {
            return $q.reject(payload);
        }

        if (requestForTokenFailed(payload)) {
            spinner.stopAll();
            progressBar.stop();
        }

        response(payload);

        return $q.reject(payload);
    }


    function requestForTokenFailed(payload) {
        return payload.config.url.indexOf('token') !== -1
            && payload.status === STATUS_BAD_REQUEST;
    }

    function isSpinnerHasToBeShown({config}) {
        return !config.noSpinner && !config.progressBar;
    }

    function isProgressBarHasToBeShown({config}) {
        return !!config.progressBar;
    }
}

export default function SpinnerInterceptor($httpProvider) {
    'ngInject';

    $httpProvider.interceptors.push(SpinnerInterceptorFunction);
}

function Spinner($rootScope, $timeout) {
    const NO_SPINNER_URL_PATTERN = /(template|\/token)/;
    const THRESHOLD = 300;

    let timeout = null;
    let requestsCompleted = 0;
    let requestsTotal = 0;

    Object.assign(this, {
        start,
        stop,
        stopAll,
    });

    function start(config) {
        if (!(!NO_SPINNER_URL_PATTERN.test(config.url) && !config.noSpinner)) {
            return;
        }

        if (!requestsTotal) {
            timeout = $timeout(() => $rootScope.isSpinnerVisible = true, THRESHOLD);
        }
        requestsTotal++;
    }

    function stop(payload) {
        if (!(!NO_SPINNER_URL_PATTERN.test(payload.config.url) && !payload.config.noSpinner)) {
            return;
        }
        requestsCompleted++;
        if (requestsCompleted >= requestsTotal) {
            stopAll();
        }
    }

    function stopAll() {
        $timeout.cancel(timeout);
        $rootScope.isSpinnerVisible = false;
        requestsCompleted = 0;
        requestsTotal = 0;
    }
}


function ProgressBar($rootScope) {
    Object.assign(this, {
        start,
        stop,
    });

    function start(config) {
        if (!config.progressBar) {
            return;
        }

        $rootScope.isProgressBarVisible = config.progressBar;
    }

    function stop(payload) {
        if (payload && !payload.config.progressBar) {
            return;
        }

        $rootScope.isProgressBarVisible = 0;
    }
}




// WEBPACK FOOTER //
// ./src/app/configs/interceptors/spinnerInterceptor.js